export default {
  state: {
    birthdayPresentDate:'', //时间
    birthdayPresentSelectData:[], //会员
  },
  //同步更新数据
  mutations: {
    updatebirthdayPresentDate(state,data){
      console.log(data)
      state.birthdayPresentDate = data
    },
    updateBirthdayPresentSelectData(state,data){
      state.birthdayPresentSelectData = data
    },

  },
  getters: {

  },
  //异步更新数据
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/birthdayPresent.js